import { render } from "./ProjetsView.vue?vue&type=template&id=1f678e0f&scoped=true"
import script from "./ProjetsView.vue?vue&type=script&lang=js"
export * from "./ProjetsView.vue?vue&type=script&lang=js"

import "./ProjetsView.vue?vue&type=style&index=0&id=1f678e0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f678e0f"]])

export default __exports__